import { useEffect, useState } from "react";
import LiveSessionListings from "./LiveSessionListing";
import { ActiveSimulate } from "./ActiveSimulate";
import { ActiveSessionBalance } from "./ActiveSessionBalance";
import { useDispatch, useSelector } from "react-redux";
import { fetchCustomerSummary } from "../../slices/customer/simulate/thunk";
import { UpdateSimulate } from "./UpdateSimulate";
import { ToastContainer } from "react-toastify";
import { Loader } from "../Utils/Loader";

export const LiveSession = ({ 
    customerId, 
    showForm, 
    setShowForm, 
    setButtonInitiateSession, 
    isSimulateView, 
    isRefreshing, 
    setIsRefreshing, 
    sessionAction ,
    setSessionAction
}) => {
    const [loading, setLoading] = useState(false);
    const [updateSession, setUpdateSession] = useState(false);
    const [terminateSessions, setTerminateSessions] = useState(false);
    const [sessionInfo, setSessionInfo] = useState({ 
        sessionId: null, 
        sequenceNumber: null,
        subscriptionId: null,
        usageEventType: null,
        sessionTime: null,
        requestedUnits: null,
        uom: null,
        attributes: []
    });
    const [currentCustomerId, setCurrentCustomerId] = useState(customerId);
    
      useEffect(() => {
    if (sessionAction === "update") {
        setUpdateSession(true);
        setTerminateSessions(false);
        setShowForm(true); 
    } else if (sessionAction === "terminate") {
        setUpdateSession(true);
        setTerminateSessions(true);
        setShowForm(true); 
    } else if (sessionAction === "initiate") {
        setUpdateSession(false);
        setTerminateSessions(false);
        setShowForm(true); 
    } else if (!sessionAction) {
        setUpdateSession(false);
        setTerminateSessions(false);
        setShowForm(false); 
    }
}, [sessionAction, setShowForm]);

    useEffect(() => {
        if (updateSession) {
            setButtonInitiateSession(false);
        }
    }, [updateSession, setButtonInitiateSession]);
   
    return (
        <div className="mt-0">
            <ToastContainer position='top-center' />
            {isRefreshing && (<Loader />)}
            <div >
                <div className={isSimulateView ? "mt-2" : ""}>
                    <ActiveSimulate 
                        showForm={showForm} 
                        setShowForm={setShowForm} 
                        sessionAction={sessionAction}
                        setSessionAction={setSessionAction}
                        sessionInfo={sessionInfo}
                        setUpdateSession={setUpdateSession}
                        terminateSessions={terminateSessions}
                        setButtonInitiateSession={setButtonInitiateSession}
                    />
                </div>
                <ActiveSessionBalance 
                    customerId={currentCustomerId} 
                    isRefreshing={isRefreshing}
                    setIsRefreshing={setIsRefreshing}
                />
                <div className="col-12">
                    <LiveSessionListings
                        customerId={customerId}
                        updateSession={updateSession}
                        setUpdateSession={setUpdateSession}
                        sessionInfo={sessionInfo}
                        setSessionInfo={setSessionInfo}
                        terminateSessions={terminateSessions}
                        setTerminateSessions={setTerminateSessions}
                    />
                </div>
            </div>
        </div>
    );
};